'use client'

import useSWRImmutable from 'swr/immutable'
import { useNormContext } from './NormContext'
import { ContentFallback } from './NormLayout'
import type { ReactElement } from 'react'

export default function MainLayoutFallback ({
  /**
   * Server component (has to be explicitly denoted with 'Use server') which renders the sidebar and content
   */
  mainLayout,
}: { mainLayout: (...props: any) => Promise<ReactElement> }) {
  const { normId } = useNormContext()
  const { data, isLoading, error } = useSWRImmutable(normId, async () => await mainLayout({ normId }), {
    revalidateOnMount: true,
  })

  if (isLoading) {
    return <ContentFallback />
  } else if (error) {
    console.error(error)
    return (
      <pre>
        {error.toString()}
      </pre>
    )
  }

  return data
}
